


interface OrderCancelledIconProps {
	className?: string,
}


const OrderCancelledIcon = (props: OrderCancelledIconProps) => {
	const { className } = props;

	return (
		<svg
			aria-hidden="true"
			focusable="false"
			data-prefix="fas"
			data-icon="custom-order-cancelled-icon"
			className={`svg-inline--fa fa-custom-order-cancelled-icon${className ? ` ${className}` : ''}`}
			role="img"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 333 512">
			<path fill="currentColor" d="m97.71,80.09c4,-23.23 21.62,-40.04 41.85,-40.04l48.05,0c20.22,0 38.04,17.02 41.85,40.24l3.6,21.22l40.64,0l-4.81,-28.03c-7.21,-42.65 -41.44,-73.48 -81.49,-73.48l-48.05,0c-39.84,0 -74.08,30.83 -81.29,73.48l-4.81,28.03l40.64,0l3.6,-21.22l0.2,-0.2z"/>
			<path fill="currentColor" d="m296.52,111.52l-260.28,0c-20.02,0 -36.24,16.22 -36.24,36.24l0,327.76c0,20.02 16.22,36.24 36.24,36.24l260.28,0c20.02,0 36.24,-16.22 36.24,-36.24l0,-327.76c0,-20.02 -16.22,-36.24 -36.24,-36.24zm-45.25,282.11c8.81,9.41 -5.21,23.63 -14.22,14.22c-6.61,-7.01 -13.21,-14.02 -19.82,-20.82c-17.22,-18.22 -34.44,-36.24 -51.66,-54.46c-23.83,25.03 -47.65,50.25 -71.48,75.28c-8.81,9.41 -23.02,-4.81 -14.22,-14.22c6.61,-7.01 13.21,-14.02 19.82,-20.82c17.22,-18.22 34.64,-36.64 51.86,-54.86c-23.83,-25.23 -47.85,-50.45 -71.68,-75.68c-8.81,-9.41 5.21,-23.63 14.22,-14.22c6.61,7.01 13.21,14.02 19.82,20.82c17.22,18.22 34.44,36.24 51.66,54.46c23.83,-25.03 47.65,-50.25 71.48,-75.28c8.81,-9.41 23.02,4.81 14.22,14.22c-6.61,7.01 -13.21,14.02 -19.82,20.82c-17.22,18.22 -34.64,36.64 -51.86,54.86c23.83,25.23 47.85,50.45 71.68,75.68z"/>
		</svg>
	);
};

export default OrderCancelledIcon;